// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__2WSBm","search":"Settings_search__bgeAw","filter":"Settings_filter__3W-oU"};